
<div class="w-full relative bg-black">
	<button (click)="closeVideoDialog()" class="absolute top-1 right-2 z-10">
		<span class="material-symbols-outlined">
			close
		</span>
	</button>
	<video class="w-full h-auto" [src]="data" style="z-index: 1;" preload="auto" autoplay muted controls playsinline></video>
</div>
